export default {
    siteApi: {
        //服务站点
        site: {
            getList: 'api/screen/site/siteList',
            saveSite: 'api/screen/site/saveSite',
            updateSite: 'api/screen/site/updateSite',
            delSite: 'api/screen/site/delSite',
        }

    }
}
